"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    root: {
        listStyle: 'none',
        paddingLeft: 0,
        margin: 0,
        display: 'flex'
    },
    item: {
        flexShrink: 1,
        minWidth: 0,
        position: 'relative',
        '&:not(:last-child)': {
            paddingRight: 21,
            marginRight: 21,
            '&::after': {
                content: '""',
                position: 'absolute',
                top: 14,
                right: 0,
                bottom: 0,
                width: 1,
                backgroundColor: theme.grey5
            }
        }
    }
});
//# sourceMappingURL=todo.style.js.map